import { z } from "zod"
import { TranslationKey } from "../i18n/translation-key"

const coordinatePair = {
  latitude: z
    .number()
    .min(-90, "common.validation.latitudeRange" satisfies TranslationKey)
    .max(90, "common.validation.latitudeRange" satisfies TranslationKey)
    .nullable()
    .optional(),
  longitude: z
    .number()
    .min(-180, "common.validation.longitudeRange" satisfies TranslationKey)
    .max(180, "common.validation.longitudeRange" satisfies TranslationKey)
    .nullable()
    .optional(),
}

const bothCoordinatesOrNeither = (data: {
  latitude?: number | null
  longitude?: number | null
}) => (data.latitude == null) === (data.longitude == null)

const coordinatesRefinement = {
  message:
    "common.validation.latitudeAndLongitudeTogether" satisfies TranslationKey,
  path: ["latitude"],
}

const storageLocationFields = {
  name: z
    .string()
    .min(1, "common.validation.required" satisfies TranslationKey)
    .max(255),
  shopifyLocationId: z.string().max(50).nullable().optional(),
  shopifyLocationName: z.string().max(255).nullable().optional(),
  ...coordinatePair,
}

export const CreateStorageLocationSchema = z
  .object(storageLocationFields)
  .refine(bothCoordinatesOrNeither, coordinatesRefinement)

export type CreateStorageLocation = z.infer<typeof CreateStorageLocationSchema>

export const UpdateStorageLocationSchema = z
  .object(storageLocationFields)
  .refine(bothCoordinatesOrNeither, coordinatesRefinement)

export type UpdateStorageLocation = z.infer<typeof UpdateStorageLocationSchema>

export interface StorageLocationDto {
  id: string
  name: string
  storeId: string
  shopifyLocationId: string | null
  shopifyLocationName: string | null
  latitude: number | null
  longitude: number | null
}

export const SetDefaultStorageLocationSchema = z.object({
  storageLocationId: z.string().uuid().nullable(),
})

export type SetDefaultStorageLocation = z.infer<
  typeof SetDefaultStorageLocationSchema
>

export interface DefaultStorageLocationDto {
  storageLocationId: string | null
}
